/**
 * Secret / PII redaction for Lark error-capture packets.
 *
 * Fail closed: anything that looks like a token, cookie, password, API key,
 * Authorization header, JWT, or .env assignment is stripped before display
 * or POST. Form field values are never collected by this flow.
 */

const REDACTED = '[redacted]';

const SECRET_PATTERNS: RegExp[] = [
  /bearer\s+[a-z0-9._\-+/=]+/gi,
  /authorization\s*[:=]\s*['"]?[^'"\s]+/gi,
  /(?:access_token|refresh_token|id_token|api[_-]?key|apikey|secret|password|passwd|pwd)\s*[:=]\s*['"]?[^'"\s]+/gi,
  /(?:eyJ[a-zA-Z0-9_-]{10,}\.[a-zA-Z0-9_-]{10,}\.[a-zA-Z0-9_-]{10,})/g,
  /\bAKIA[0-9A-Z]{16}\b/g,
  /(?:cookie|set-cookie)\s*[:=]\s*[^\s]+/gi,
  /^\s*[A-Z][A-Z0-9_]{2,}\s*=\s*.+$/gm,
];

export function redactSecrets(value: string | null | undefined): string {
  if (value == null) return '';
  let next = String(value);
  for (const pattern of SECRET_PATTERNS) {
    next = next.replace(pattern, REDACTED);
  }
  return next;
}

/** Path only — drop query/hash so tokens in `?secret=` never land in the packet. */
export function pathOnly(url: string | null | undefined): string {
  if (!url) return '';
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const parsed = new URL(url);
      return parsed.pathname || '/';
    }
  } catch {
    /* fall through */
  }
  const cut = url.split(/[?#]/)[0];
  return cut || '/';
}

export function pageNameFromRoute(pathname: string): string {
  const parts = pathOnly(pathname)
    .split('/')
    .filter(Boolean)
    .filter((part) => !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(part));
  if (parts.length === 0) return 'Home';
  return parts.join(' / ');
}
